import { useContext, useEffect, useRef, useState } from 'react';

import { TrackingContext } from 'context/Tracking';
import { UserContext } from 'context/User';
import { useEffectOnce } from 'hooks/useEffectOnce';
import { useCheckInstanceLoaded } from 'pages/SignUp/useCheckInstanceLoaded';
import { useHistory } from 'utils/router';

import { signUpRoutes } from './routes';
import GrotRocketAnimationLoader from './GrotRocketAnimationLoader/GrotRocketAnimationLoader';
import { CLOUD_SIGNUP_FLOW_EVENT } from 'utils/consts';
import { GraphAnimationLoader } from './GraphAnimationLoader';

export const LoadingInstanceAnimation = () => {
  const [, { trackEvent, faro }] = useContext(TrackingContext);
  const [
    {
      userData,
      userMeta: { userIsLoggedIn, userHasConfirmedEmail, userHasOrganisations },
    },
  ] = useContext(UserContext);

  const redirectTo = useCheckInstanceLoaded();
  const hasRedirected = useRef(false);
  const history = useHistory();

  // can be removed when rocket loader experiment is complete
  const [experimentEnabled, _] = useState(() => {
    const enabled = Math.random() < 0.5;

    trackEvent({
      name: CLOUD_SIGNUP_FLOW_EVENT,
      componentKey: enabled ? 'rocket_loader_enabled' : 'rocket_loader_disabled',
    });

    return enabled;
  });

  // Navigate exactly once. Assigning window.location.href on every render would
  // cancel the in-flight navigation and start a new one, producing repeated
  // cancelled requests to /set-redirect-and-login.
  useEffect(() => {
    if (!redirectTo || hasRedirected.current) {
      return;
    }
    hasRedirected.current = true;

    faro.trackEvent('user-hg-instance-loaded-and-now-redirecting', { redirectTo });
    trackEvent({
      name: 'user-hg-instance-loaded-and-now-redirecting',
      userId: userData?.id,
      redirectToURL: redirectTo,
    });

    window.location.href = redirectTo;
  }, [redirectTo, faro, trackEvent, userData?.id]);

  useEffectOnce(() => {
    if (!userIsLoggedIn) {
      history.push(signUpRoutes.createUser);
    } else if (!userHasConfirmedEmail) {
      history.push(signUpRoutes.checkInbox);
    } else if (!userHasOrganisations) {
      history.push(signUpRoutes.selectOrganisation);
    }
  });

  if (!userIsLoggedIn || !userHasConfirmedEmail) {
    return null;
  }

  return (
    experimentEnabled ? <GrotRocketAnimationLoader /> : <GraphAnimationLoader />
  );
};
